module.exports = __webpack_public_path__ + "img/Sonder2022.4da7ed5b.jpg";